export const SHARED_DESIGN_DEVICE_KEYS = ['desktop', 'tablet', 'mobile'] as const;

export type SharedDesignDeviceKey = typeof SHARED_DESIGN_DEVICE_KEYS[number];

type SharedDesignDevice = {
  label: string;
  width: number;
  icon: string;
};

export const SHARED_DESIGN_DEVICES: Record<SharedDesignDeviceKey, SharedDesignDevice> = {
  desktop: { label: 'Desktop', width: 1280, icon: 'fa-solid fa-desktop' },
  tablet: { label: 'Tablet', width: 768, icon: 'fa-solid fa-tablet-screen-button' },
  mobile: { label: 'Mobile', width: 375, icon: 'fa-solid fa-mobile-screen-button' },
};

export function parseSharedDesignDevice(value: string | null): SharedDesignDeviceKey {
  return SHARED_DESIGN_DEVICE_KEYS.find((key) => key === value) || 'desktop';
}
